// import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import Cookies from 'universal-cookie';
// // import request from "../utilities/request";
// const cookies = new Cookies();

// export const authApi = createApi({
//   reducerPath: 'authApi',
//   baseQuery: fetchBaseQuery({ 
//     baseUrl: `${process.env.REACT_APP_BASE_URL}/admin/v1/auth/`,
//     prepareHeaders: (headers) => {
//       const token = window.localStorage.getItem('token');
//       if (token) {
//         headers.set('authorization', `Bearer ${token}`);
//       }
//       // Set Content-Type if not already set
//       if (!headers.get('Content-Type')) {
//         headers.set('Content-Type', 'application/json');
//       }
//       return headers;
//     },
//   }),
//   endpoints: (builder) => ({
//     adminSignUp: builder.mutation({
//       query: ({ name, email, phoneNumber }) => ({
//         url: 'invite/admin',
//         method: 'POST',
//         body: { name, email, phoneNumber },
//         headers: {
//           'Content-type': 'application/json',
//         },
//       }),
//     }),
//     adminLoginEmail: builder.mutation({
//       query: (payload) => ({
//         url: 'login/email',
//         method: 'POST',
//         body: payload,
//         headers: {
//           'Content-Type': 'application/json',
//         },

//       }),
//     }),
//     adminLoginPhone: builder.mutation({
//       query: (payload) => ({
//         url: 'sendOtp',
//         method: 'POST',
//         body: payload,
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       }),
//     }),

//     verifyOtp: builder.mutation({
//       query: (payload) => ({
//         url: 'verifyOtp',
//         method: 'POST',
//         body: payload,


//       }),
//     }),
//     changePassword: builder.mutation({
//       query: ({ encryptedData }) => ({
//         url: 'change/password',
//         method: 'PATCH',
//         body: { encryptedData },
//         // credentials: 'include',
//         headers: {
//           'Content-type': 'application/json',
//           // Authorization: `Bearer ${token}`,
//         },
//       }),
//     }),
//     requestResetPassword: builder.mutation({
//       query: ({ encryptedData }) => ({
//         url: 'resetpassword',
//         method: 'POST',
//         body: { encryptedData },


//       }),
//     }),
//     verifyEmail: builder.mutation({
//       query: ({ email, token }) => ({
//         url: `verify/${email}/${token}`,
//         method: 'GET',



//       }),
//     }),
//     resetPassword: builder.mutation({
//       query: ({ email, encryptedData }) => ({
//         url: `verify/${email}`,
//         method: 'POST',
//         body: { encryptedData },


//       }),
//     }),
//     logout: builder.mutation({
//       query: ({ uid }) => ({
//         url: `logout/${uid}`,
//         method: 'PATCH',
//         headers: {
//           'Content-type': 'application/json',
//         },
//       }),
//     }),

//       getProfile: builder.mutation({
//       query: ({uid }) => ({
//         url: `profile/${uid}`,
//         method: 'GET',



//       }),
//     }),
//   }),
// });

// export const { useAdminSignUpMutation, useLogoutMutation,useChangePasswordMutation, useGetProfileMutation,
//   useAdminLoginEmailMutation, useAdminLoginPhoneMutation, useVerifyOtpMutation, useRequestResetPasswordMutation, useVerifyEmailMutation, useResetPasswordMutation
// } = authApi;






import { createApi } from '@reduxjs/toolkit/query/react';
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_BASE_URL),
  endpoints: (builder) => ({
    adminSignUp: builder.mutation({
      query: ({ name, email, phoneNumber }) => ({
        url: 'admin/v1/auth/invite/admin',
        method: 'POST',
        body: { name, email, phoneNumber },
        headers: {
          'Content-type': 'application/json',
        },
      }),
    }),
    adminLoginEmail: builder.mutation({
      query: (payload) => ({
        url: 'admin/v1/auth/login/email',
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
        },

      }),
    }),
    adminLoginPhone: builder.mutation({
      query: (payload) => ({
        url: 'admin/v1/auth/sendOtp',
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),

    verifyOtp: builder.mutation({
      query: (payload) => ({
        url: 'admin/v1/auth/verifyOtp',
        method: 'POST',
        body: payload,


      }),
    }),
    changePassword: builder.mutation({
      query: ({ encryptedData }) => ({
        url: 'admin/v1/auth/change/password',
        method: 'PATCH',
        body: { encryptedData },
        // credentials: 'include',
        headers: {
          'Content-type': 'application/json',
          // Authorization: `Bearer ${token}`,
        },
      }),
    }),
    // requestResetPassword: builder.mutation({
    //   query: ({ encryptedData }) => ({
    //     url: 'admin/v1/auth/resetpassword',
    //     method: 'POST',
    //     body: { encryptedData },


    //   }),
    // }),
      requestResetPassword: builder.mutation({
      query: (payload) => ({
        url: 'admin/v1/auth/resetpassword',
        method: 'POST',
        body: payload,


      }),
    }),
    verifyEmail: builder.mutation({
      query: ({ email, token }) => ({
        url: `admin/v1/auth/verify/${email}/${token}`,
        method: 'GET',



      }),
    }),
    resetPassword: builder.mutation({
      query: ({ email, payload }) => ({
        url: `admin/v1/auth/verify/${email}`,
        method: 'POST',
        body:  payload ,


      }),
    }),
    logout: builder.mutation({
      query: ({ uid }) => ({
        url: `admin/v1/auth/logout/${uid}`,
        method: 'PATCH',
        headers: {
          'Content-type': 'application/json',
        },
      }),
    }),

      getProfile: builder.mutation({
      query: ({uid }) => ({
        url: `admin/v1/auth/profile/${uid}`,
        method: 'GET',



      }),
    }),
  }),
});

export const { useAdminSignUpMutation, useLogoutMutation,useChangePasswordMutation, useGetProfileMutation,
  useAdminLoginEmailMutation, useAdminLoginPhoneMutation, useVerifyOtpMutation, useRequestResetPasswordMutation, useVerifyEmailMutation, useResetPasswordMutation
} = authApi;